<template>
  <div>
    <div>
      <div class="tips">审核意见</div>
      <div class="steps">
        <div v-for="(item, index) in rlReviewers" :key="index">
          <el-button
            :type="btnActive == index ? 'primary ' : ''"
            @click="handleClickRevier(index)"
            >{{ item.xm }}/
            <span
              :style="{
                color:
                  item.statusname == '通过'
                    ? btnActive == index
                      ? '#fff'
                      : '#409EFF'
                    : '#ff0000',
              }"
              >{{ item.statusname }}</span
            >
          </el-button>
        </div>
        <div>
          <!-- <div>
            <el-button
              @click="handleClickRevier(rlReviewers.length)"
              :type="btnActive == rlReviewers.length ? 'primary ' : ''"
              >{{ user.xm }}</el-button
            >
          </div> -->
        </div>
      </div>
      <div class="clearfix rlr">
        <div class="label">审核意见<span class="required">*</span></div>
        <div class="input">
          <div v-for="(item, index) in rlReviewers" :key="item.id">
            <el-input
              type="textarea"
              maxlength="500"
              rows="6"
              :disabled="item.status != 2 || item.ygbh != user.ygbh"
              v-model="item.bz"
              v-if="btnActive == index"
            ></el-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { getTaskrkshtz, saveTaskRlAudit } from "@/api/task.js";

export default {
  name: "taskClaimSetting",
  computed: { ...mapGetters(["deptUser", "user", "task"]) },
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      btnActive: 0,
      rlReviewers: [],
      bz: null,
      parentDialog: false,
    };
  },
  created() {
    getTaskrkshtz({ taskId: this.mxParams.id, type: 1 }).then((res) => {
      if (res.code == 0) {
        this.rlReviewers = res.data.rlReviewers;
        this.bz = res.data.rlReviewers[0].bz;
        if (
          this.rlReviewers[0].ygbh != this.user.ygbh ||
          this.rlReviewers[0].status != 2
        ) {
          this.$store.dispatch("task/setRwshBtnPermission", { flag: false });
        }
      }
    });
  },
  methods: {
    saveForm(status) {
      this.bz = this.rlReviewers[this.btnActive].bz;
      if (!this.bz) {
        this.$message.error("审核意见不能为空！");
        return;
      }
      let params = {
        isAdmin: this.user.isAdmin,
        bz: this.bz,
        taskId: this.mxParams.id,
        id: this.rlReviewers[this.btnActive].id,
        status,
      };

      saveTaskRlAudit(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$store.dispatch(
            "task/fetchTaskListAction",
            this.task.taskList.params
          );
          this.$emit("giveFather", this.parentDialog);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    giveFather() {
      this.parentDialog = false;
    },

    handleClickRevier(index) {
      this.btnActive = index;
      if (index == this.rlReviewers.length - 1) {
        this.bz = null;
      } else {
        this.bz = this.rlReviewers[index].bz;
      }
      if (
        this.rlReviewers[index].ygbh != this.user.ygbh ||
        this.rlReviewers[index].status != 2
      ) {
        this.$store.dispatch("task/setRwshBtnPermission", { flag: false });
      } else {
        this.$store.dispatch("task/setRwshBtnPermission", { flag: true });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.tips {
  background-color: #d7d7d7;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  margin: 15px 0;
}
.rlr {
  display: flex;
  .label {
    width: 80px;
    line-height: 40px;
    text-align: right;
    padding-right: 10px;
  }
  .input {
    width: calc(100% - 80px);
  }
}
.required {
  color: #ff0000;
}
.steps {
  display: flex;
  margin-bottom: 15px;
  margin-left: 80px;
  > div {
    margin-right: 15px;
  }
}
</style>